import type { LLMMessage } from '../types';

export class Memory {
  private messages: LLMMessage[];
}
